import { useAuth } from "../scripts/app";
import { hasRole, findRequiredRole } from "../scripts/auth";

export default function IfRole({ role, route, children }) {
  const { currentUserToken, loading } = useAuth();

  if (loading || !currentUserToken) return;

  if (route) role = findRequiredRole(route);

  if (!role) return children;

  return hasRole(currentUserToken.claims.role, role) ? children : null;
}
